import { useContext, useEffect, useState } from "react";
import {
  ErrorMessage,
  Input,
  Label,
  Textarea,
} from "../components/styledComponent/formInputs";
import { toast } from "react-toastify";
import ReactQuill from "react-quill";
import Button from "../common/Button";
import Loading from "../components/Loading";
import { addBlog, fetchTags } from "../api/dashboardApi";
import { Context } from "../context/MainContext";
import { Link } from "react-router-dom";
import AddTags from "../components/AddTags";
import ReactModal from "react-modal";
import Select from "react-select";

const AddBlog = () => {
  const { user } = useContext(Context);
  const [inputError, setInputError] = useState({});
  const [fileName, setfileName] = useState("");
  const [title, setTitle] = useState("");
  const [tag, setTag] = useState("");
  const [img, setimg] = useState("");
  const [tags, setTags] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [summary, setSummary] = useState("");
  const [content, setContent] = useState("");
  const [isFeatured, setIsFeatured] = useState("false");
  const [uploadedFile, setuploadedFile] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingTags, setLoadingTags] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];

    if (file?.size > 329715) {
      toast.warning("File too big, max size 300kb");
    } else {
      const base64 = await convertToBase64(file);
      setimg(base64);
      setfileName(file?.name);
      setuploadedFile(file);
    }
  };

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ align: ["right", "center", "justify"] }],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image"],
      ["clean"],
    ],
  };

  const validate = () => {
    let titleError = "";
    let tagError = "";
    // let youtubeError = "";
    let summaryError = "";
    let contentError = "";
    let uploadedFileError = "";

    if (!title) {
      titleError = "title is required";
    }
    if (tag.length < 1) {
      tagError = "tag is required";
    }
    // if (!youtube) {
    //   youtubeError = "youtube link is required";
    // }
    if (!summary) {
      summaryError = "summary is required";
    }
    if (!content) {
      contentError = "content is required";
    }
    if (!uploadedFile) {
      uploadedFileError = "cover image is required";
    }

    if (
      titleError ||
      tagError ||
      // youtubeError ||
      uploadedFileError ||
      summaryError ||
      contentError
    ) {
      setInputError((curr) => {
        return {
          ...curr,
          title: titleError,
          tag: tagError,
          summary: summaryError,
          content: contentError,
          uploadedFile: uploadedFileError,
          // youtube: youtubeError,
        };
      });
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    const checkValidate = validate();
    if (checkValidate) {
      setInputError({});
      setLoading(true);
      try {
        // const tagsData = tag?.map((item) => {
        //   return item?.value;
        // });

        let formData = new FormData();
        formData.append("title", title);
        formData.append("tag", tag?.value);
        formData.append("summary", summary);
        formData.append("content", content);
        formData.append("isFeatured", isFeatured === "true" ? true : false);
        formData.append("uploadedFile", uploadedFile);

        // for (const value of formData.values()) {
        //   console.log(value);
        // }
        await addBlog(formData);

        setLoading(false);
        toast.success("Blog added successfully");
        // setStep(2);
        setTitle("");
        setimg("");
        setContent("");
        setSummary("");
        setTag("");
        setuploadedFile("");
        setfileName("");
        setIsFeatured("false");
      } catch (err) {
        setLoading(false);
        const message =
          (err.response && err.response.data && err.response.data.message) ||
          err.message ||
          err.toString();
        toast.error(message);
      }
    }
  };

  useEffect(() => {
    const handleFetchTagss = async () => {
      if (user?.id) {
        setLoadingTags(true);
        try {
          const res = await fetchTags();

          if (res.data?.tags.length > 0) {
            const selectTags = res.data?.tags?.map((item) => {
              return { value: item.name, label: item.name };
            });
            setTags(selectTags);
          } else {
            setTags(res.data?.tags);
          }
          setLoadingTags(false);
        } catch (err) {
          setLoadingTags(false);
          const message =
            (err.response && err.response.data && err.response.data.message) ||
            err.message ||
            err.toString();
          toast.error(message);
        }
      }
    };

    handleFetchTagss();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id, refresh]);

  const handleChange = (selectedOption) => {
    // console.log("selectedOption", selectedOption);
    setTag(selectedOption);
  };

  return (
    <div className="addBlog">
      <ReactModal
        className="modalMain"
        overlayClassName="modal-overlayCenter"
        ariaHideApp={false}
        isOpen={modalIsOpen}
        onRequestClose={() => setModalIsOpen(false)}
        contentLabel="Add tags Modal"
      >
        <AddTags setModalIsOpen={setModalIsOpen} setRefresh={setRefresh} />
      </ReactModal>
      <div className="addBlog__main">
        <h1 className="addBlog__main__title">
          Add Blog
          <Link to="/dashboard/blogs">
            <i className="ti-arrow-circle-left"></i>
          </Link>
        </h1>
        <div className="addBlog__main__form">
          <div className="addBlog__main__form__item">
            <Label htmlFor="title">
              Title <span>*</span>
            </Label>

            <Input
              width="300px"
              id="title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
            <ErrorMessage>{inputError?.title}</ErrorMessage>
          </div>

          <div className="addBlog__main__form__item">
            <div style={{ marginBottom: 10 }}>
              <Button
                onClick={() => setModalIsOpen(true)}
                height="35px"
                width="120px"
              >
                Create Tag
              </Button>
            </div>

            <Label htmlFor="tag">
              Tag <span>*</span>
            </Label>
            <Select
              // isMulti
              name="tags"
              options={tags}
              className="basic-multi-select"
              value={tag}
              onChange={handleChange}
              classNamePrefix="select"
            />
            <ErrorMessage>{inputError?.tag}</ErrorMessage>
          </div>
          <div className="addBlog__main__form__item">
            <Label htmlFor="featured">Featured</Label>

            <div style={{ display: "flex", gap: 50, marginTop: 10 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <label htmlFor="featuredF">False</label>
                <Input
                  style={{ width: 20 }}
                  type="radio"
                  id="featuredF"
                  name="featured"
                  value={false}
                  checked={isFeatured === "false"}
                  onChange={(e) => setIsFeatured(e.target.value)}
                />
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <label htmlFor="featuredT">True</label>
                <Input
                  style={{ width: 20 }}
                  type="radio"
                  id="featuredT"
                  value={true}
                  name="featured"
                  checked={isFeatured === "true"}
                  onChange={(e) => setIsFeatured(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="addBlog__main__form__item">
            <Label htmlFor="summary">
              Summary <span>*</span>
            </Label>

            <Textarea
              width="300px"
              id="summary"
              value={summary}
              onChange={(e) => setSummary(e.target.value)}
              rows={3}
              style={{ width: "100%" }}
            />
            <ErrorMessage>{inputError?.summary}</ErrorMessage>
          </div>
          <div
            className="careerApp__main__input"
            style={{ marginBottom: "20px" }}
          >
            <Label htmlFor="cover">
              Cover Image <span>*</span>
            </Label>
            <div>
              {img && (
                <img
                  src={img}
                  alt=""
                  style={{ width: 200, marginBottom: 10 }}
                />
              )}
            </div>
            {/* <br /> */}
            <input
              style={{ display: "none" }}
              id="cover"
              type="file"
              onChange={(e) => handleFileUpload(e)}
              accept="image/png, image/gif, image/jpeg, image/jpg, image/webp"
            />
            <label className="careerApp__main__fileLabel" htmlFor="cover">
              {!fileName ? "Choose File" : fileName}
              <span>Max file size: 300kb</span>
            </label>
            <ErrorMessage>{inputError?.uploadedFile}</ErrorMessage>
          </div>

          <div className="addBlog__main__form__item">
            <Label htmlFor="content">
              Content <span>*</span>
            </Label>

            <ReactQuill
              id="content"
              theme="snow"
              modules={modules}
              value={content}
              onChange={setContent}
              //    value={value} onChange={setValue}
              style={{ height: 500 }}
            />
            <ErrorMessage>{inputError?.content}</ErrorMessage>
          </div>
        </div>

        <div className="addBlog__main__form__btn">
          <Button onClick={handleSubmit}>
            {loading ? <Loading button={true} /> : "Add"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AddBlog;
